import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../routes';

export default function Hero() {
  const navigate = useNavigate();

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-eyebrow">🏥 Adverse Drug Reaction Reporting System</div>
        <h1 className="hero-title">
          Report Your <span className="gradient-text">Medication Side Effects</span><br />Safely & Securely
        </h1>
        <p className="hero-subtitle">
          A confidential self-reporting portal for patients to share adverse drug reactions
          from ongoing medications. Your information helps improve patient safety.
        </p>
        <div className="hero-actions">
          <button className="btn btn-primary" style={{ padding: '14px 32px', fontSize: '1rem' }} onClick={() => navigate(ROUTES.REGISTER_PERSONAL)}>
            📋 Submit Your Report
          </button>
          <button className="btn btn-outline" style={{ padding: '14px 28px', fontSize: '1rem' }} onClick={() => navigate(ROUTES.QR)}>
            📱 Scan QR Code
          </button>
          <button className="btn btn-secondary" style={{ padding: '14px 28px', fontSize: '1rem' }} onClick={() => navigate(ROUTES.DASHBOARD)}>
            📊 View Records
          </button>
        </div>
        <div className="hero-stats">
          {[['🛡️', 'Confidential', 'Secure & Private'], ['⚡', 'Instant', 'Real-time Submission'], ['📋', 'ADR Focused', 'Drug Reaction Reports'], ['🏥', 'Verified', 'Hospital-Registered']].map(([icon, val, label]) => (
            <div className="hero-stat" key={label}>
              <div className="hero-stat-number">{icon}</div>
              <div className="hero-stat-number" style={{ fontSize: '1.2rem' }}>{val}</div>
              <div className="hero-stat-label">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
